export default __webpack_public_path__ + "static/media/bluerock-logo.11ab1db5.png";